// src/pages/Admin/CategoryLevelFetchSelection.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import TitleWithBack from '../../components/common/TitleWithBack';

function CategoryLevelFetchSelection() {
  const [matrix, setMatrix] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [savingKey, setSavingKey] = useState(null);

  useEffect(() => {
    fetchMatrix();
  }, []);

  const fetchMatrix = () => {
    setLoading(true);
    axios.get('/api/apigateway/fetch-selections')
      .then((response) => {
        setMatrix(response.data);
        setLoading(false);
      })
      .catch(() => {
        setError('Error fetching category/level selections.');
        setLoading(false);
      });
  };

  const toggle = (cell) => {
    const key = `${cell.categoryId}:${cell.levelId}`;
    setSavingKey(key);
    axios.put('/api/apigateway/fetch-selections', {
      categoryId: cell.categoryId,
      levelId: cell.levelId,
      enabled: !cell.enabled
    })
      .then((response) => {
        setMatrix((prev) => prev.map((c) =>
          c.categoryId === cell.categoryId && c.levelId === cell.levelId ? response.data : c
        ));
        setSavingKey(null);
      })
      .catch(() => {
        setError('Error updating selection.');
        setSavingKey(null);
      });
  };

  const categories = [...new Map(matrix.map((c) => [c.categoryId, c.categoryName])).entries()];
  const levels = [...new Map(matrix.map((c) => [c.levelId, c.levelName])).entries()];

  const findCell = (categoryId, levelId) =>
    matrix.find((c) => c.categoryId === categoryId && c.levelId === levelId);

  return (
    <div className="container-fluid mt-2 px-4">
      <TitleWithBack title="Category / Level Fetch Selection" />
      <p>
        Only the category + level combinations checked here will have their
        programs pulled from the API Gateway when a series sync runs.
      </p>

      {error && <div className="alert alert-danger">{error}</div>}

      {loading ? (
        <p>Loading...</p>
      ) : matrix.length === 0 ? (
        <p>No program categories/levels found. Sync categories and levels first.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Category \ Level</th>
                {levels.map(([levelId, levelName]) => (
                  <th key={levelId}>{levelName}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {categories.map(([categoryId, categoryName]) => (
                <tr key={categoryId}>
                  <td><strong>{categoryName}</strong></td>
                  {levels.map(([levelId]) => {
                    const cell = findCell(categoryId, levelId);
                    const key = `${categoryId}:${levelId}`;
                    return (
                      <td key={levelId} className="text-center">
                        {cell && (
                          <input
                            type="checkbox"
                            checked={cell.enabled}
                            disabled={savingKey === key}
                            onChange={() => toggle(cell)}
                          />
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default CategoryLevelFetchSelection;
